import setTransition from './setTransition.js';
import transitionStart from './transitionStart.js';
import transitionEnd from './transitionEnd.js';

export defa mx-1  ult {
  setTransition,
  transitionStart,
  transitionEnd,
};
